/* 콜 전광판을 열고 닫기 위해 추가됨 */
const getDefaultState = () => {
  return {
    windowObj: null
  };
};
const state = getDefaultState();

const getters = {
  windowObj: (state) => {
    return state.windowObj;
  }
};

const mutations = {
  setDashboardWinObj(state, window) {
    state.windowObj = window;
  },
  closeDashboardWin(state) {
    if (state.windowObj) {
      state.windowObj.close();
    }
  }
};

export default {
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/report/callConsultStatus.js